<div class="confirm-container">
  <div class="confirm-card">
    <div class="confirm-header">
      <svg xmlns="http://www.w3.org/2000/svg" class="check-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <h1 class="confirm-title">Confirmación de Pago Payphone</h1>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-section">
      <div class="spinner"></div>
      <p class="loading-text">{{ confirmResponse ? 'Creando factura...' : 'Confirmando transacción...' }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-section">
      <div class="error-icon">❌</div>
      <p class="error-message">{{ error }}</p>
      <button *ngIf="eventSlug" (click)="goBackToEvent()" class="back-button">
        Volver al evento
      </button>
    </div>

    <!-- Success/Response State -->
    <div *ngIf="confirmResponse && !isLoading" class="confirm-body">
      <!-- Status Badge -->
      <div class="status-badge" [style.background-color]="getStatusColor()">
        <span class="status-icon">{{ getStatusIcon() }}</span>
        <span class="status-text">{{ confirmResponse.transactionStatus }}</span>
      </div>

      <!-- Invoice Created Message -->
      <div *ngIf="invoiceResponse && confirmResponse.transactionStatus === 'Approved'" class="success-message">
        <div class="success-icon">✅</div>
        <h2 class="success-title">¡Pago Procesado Exitosamente!</h2>
        <p class="success-description">Tu factura ha sido creada y los tickets han sido reservados.</p>
        <div class="invoice-id">
          <strong>ID de Factura:</strong> {{ invoiceResponse.data.factura.facturaid }}
        </div>
        <div *ngIf="invoiceResponse.data.newUserCreated" class="new-user-notice">
          <p>🎉 Se ha creado una cuenta para ti. Revisa tu correo para más detalles.</p>
        </div>
      </div>

      <!-- Main Details -->
      <div class="data-section">
        <h2 class="section-title">Detalles de la Transacción</h2>
        
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">ID Transacción:</span>
            <span class="detail-value">{{ confirmResponse.transactionId }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Autorización:</span>
            <span class="detail-value">{{ confirmResponse.authorizationCode }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Monto:</span>
            <span class="detail-value amount">{{ (confirmResponse.amount / 100) | number:'1.2-2' }} {{ confirmResponse.currency }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Fecha:</span>
            <span class="detail-value">{{ confirmResponse.date }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Email:</span>
            <span class="detail-value">{{ confirmResponse.email }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Teléfono:</span>
            <span class="detail-value">{{ confirmResponse.phoneNumber }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Tarjeta:</span>
            <span class="detail-value">{{ confirmResponse.cardBrand }} (**** {{ confirmResponse.lastDigits }})</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Tipo:</span>
            <span class="detail-value">{{ confirmResponse.cardType }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Tienda:</span>
            <span class="detail-value">{{ confirmResponse.storeName }}</span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Referencia:</span>
            <span class="detail-value">{{ confirmResponse.reference }}</span>
          </div>

          <div class="detail-item full-width">
            <span class="detail-label">Cart ID:</span>
            <span class="detail-value">{{ confirmResponse.clientTransactionId }}</span>
          </div>

          <div class="detail-item full-width">
            <span class="detail-label">Mensaje:</span>
            <span class="detail-value">{{ confirmResponse.message }}</span>
          </div>
        </div>
      </div>

      <!-- Raw Response -->
<!--       <details class="raw-data">
        <summary class="raw-title">Ver Respuesta Completa (JSON)</summary>
        <pre class="raw-content">{{ confirmResponse | json }}</pre>
      </details> -->
    </div>

    <!-- Initial Query Params (for debugging) -->
    <!-- <div *ngIf="paymentData && !confirmResponse && !isLoading && !error" class="confirm-body">
      <div class="data-section">
        <h2 class="section-title">Parámetros Recibidos:</h2>
        <pre class="data-display">{{ paymentData | json }}</pre>
      </div>

      <div class="message-section">
        <p class="info-message">Los datos del pago se han registrado en la consola del navegador.</p>
        <p class="info-submessage">Presiona F12 para ver los logs completos.</p>
      </div>
    </div> -->

    <div class="confirm-footer">
      <button (click)="returnToHome()" class="btn-home">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        Volver al Inicio
      </button>
    </div>
  </div>
</div>
